import { render, staticRenderFns } from "./TabsDynamic.vue?vue&type=template&id=480bb0cc&scoped=true&"
import script from "./TabsDynamic.vue?vue&type=script&lang=js&"
export * from "./TabsDynamic.vue?vue&type=script&lang=js&"
import style0 from "./TabsDynamic.vue?vue&type=style&index=0&id=480bb0cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480bb0cc",
  null
  
)

export default component.exports